import React from "react";
import { motion } from "framer-motion";

function RepoLanguage({ language }) {
  return (
    <motion.span
      className={`inline-block rounded-full px-2 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 ${
        language === "JavaScript"
          ? "bg-yellow-300"
          : language === "Vue"
          ? "bg-green-300"
          : language === "CSS"
          ? "bg-blue-400"
          : language === "SCSS"
          ? "bg-pink-300"
          : language === "TypeScript"
          ? "bg-teal-400"
          : language === "HTML"
          ? "bg-red-300"
          : language === "React"
          ? "bg-purple-300"
          : ""
      }`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.8 }}
    >
      {language}
    </motion.span>
  );
}

export default RepoLanguage;
